export const pageTitle = (title) => {
    return ( document.title = title + " - Epitome Research & Innovations Inc.");
  }